import React from 'react';
import Navigationtitle from '../include/Navigationtitle';
import { aboutAuction, Heading } from '../../constants/Images';

  function Aboutus(match) {

  return (
  <>
     <Navigationtitle data={match} /> 
     <div className="about-area default-padding about-home" >
        <div className="container-fluid">
            <div className="row">
                <div className="about-info">

                    <div className="site-heading text-center">
                    <div className="col-md-12">
                        <h2>About Super Player Auction</h2>
                        <div className="clear"></div>
                        <img src={Heading} />
                    </div>
                  </div>


                    <div className="col-md-5 thumb">
                        <img   src={aboutAuction}   alt="Thumb"/>
                    </div>
                    <div className="col-md-7 info p-justify">
                        <p>Each tournament coordinator knows that it is so difficult to figure out piles of entry forms, make the
                        draws out of it and matches to have an incredible tournament. Super Player Auction is intended to
                        deal with a competition and gives you useful, and proficient abilities. Super Player Auction offers
                        loads of functionalities with unmatched exactness and proficiency. Super Player Auction is made for
                        all type of sports like Cricket, Hockey, Volleyball, Basketball and any sport you can imagine. If you are
                        organizing any kind of tournament of any sport Super Player Auction is ready to make it happen in
                        the most professional manner.

                        </p>
                        <p>
                            In the last 6 years we have organized Cricket Player Auctions, Hockey Player Auctions, Volleyball
                            Player Auctions and Kabaddi Player Auctions in various tournaments. It is a great player auction
                            software and player auction mobile application where you can find all the live actions taken place.
                        </p>
                        
                    </div>
                </div>
             </div>
          </div>
       </div>
 </>
  )
}

export default  Aboutus
